import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import Image from '../Image/Image'

export const StyledImageContainer = styled.div`
  justify-content: center;
  display: flex;
  margin-bottom: ${pxToRem(10)};
  align-items: center;
  height: ${pxToRem(160)};
  * {
    object-fit: cover;
    border-radius: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(30)} ${pxToRem(5)};
    height: ${pxToRem(160)};
    width: 100%;
  }
`

export const StyledPlaceholder = styled.div`
  margin-bottom: ${pxToRem(10)};
  border-radius: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(30)} ${pxToRem(5)};
  height: ${pxToRem(160)};
  background-color: ${(props) =>
    props.color || props.theme.colors.unique.white};
`
